
import { FC } from 'react';

export interface ITextAreaProps extends Omit<React.InputHTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  validation?: 'error' | undefined;
  validationMsg?: string;
  rows?: number;
}

export const TextArea: FC<ITextAreaProps> = ({ onChange, value, validation, validationMsg, name, disabled, rows, ...rest }) => {
  let classes = "cb-input cb-textarea";
  if (validation === 'error') {
    classes += ' cb-validation-error';
  }
  
  return <>
    <div className={classes}>
      <div className="cb-validation-label-input">
        <textarea disabled={disabled} rows={rows || 3} onChange={onChange} {...rest} name={name} value={value || ''} />
        {/* <button type="button" className="cb-btn cb-btn-square cb-btn-greyscale">
        <span className="cb-icon cb-x-mark" aria-hidden="true"></span><span className="sr-only">Clear</span>
      </button> */}
      </div>
      {validation === 'error' &&
        <i className="cb-validation-icon cb-icon cb-exclamation" aria-hidden="true"></i>
      }
    </div>
    {validation === 'error' &&
      <p className="cb-input-helper cb-validation-error">{validationMsg || ''}</p>
    }
  </>;
};

